import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRedirectToRetailer = loadable(() => import(/* webpackChunkName: "content/registry/guest/retailer-redirect" */ './RedirectToRetailerNav'), 'RedirectToRetailerNav');
